import React from "react";
import Modal from "../../../../../components/ui/Modal";
import Button from "../../../../../components/ui/Button";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { useNavigate } from "react-router-dom";
import { remittanceActions } from "../../../state/remittanceSlice";
import { remittanceApi } from "../../../api/remittanceApi";
import { toast } from "react-toastify";
import { AppStrings, logApiErrorToSentry } from "../../../utils";

interface NeftRtgsModalProps {
  visible: boolean;
  // onShare: () => void;
  // onConfirm: () => void;
  // onHome: () => void;
  // onClose: () => void;
}

const DetailRow = ({ label, value }: { label: string; value: any }) => (
  <div className="flex gap-1 text-gray-700">
    <span className="font-semibold text-gray-500">{label}</span>
    <span className="font-semibold break-all">{value}</span>
  </div>
);

export const NeftRtgsModal: React.FC<NeftRtgsModalProps> = ({ visible }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const authState = useAppSelector((state) => state.auth);
  const remitterState = useAppSelector((state) => state.remittance);
  const { transactionDetail, payment } = useAppSelector((state) => state.remittance);

  const onClickShareAccDetails = () => {
    dispatch(remittanceActions.setShareNeftRtgsAccount({ loading: true }));
    remittanceApi
      .getShareAccountDetailsByTxn(transactionDetail?.data?.transactionNumber)
      .then(() => {
        toast.success("Account details shared to whatsapp");
        dispatch(remittanceActions.setShareNeftRtgsAccount({ loading: false }));
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.error?.type || err?.response?.data?.error || AppStrings.GENERIC_ERROR
        );
        logApiErrorToSentry(err, "onClickShareAccDetails");
        dispatch(remittanceActions.setShareNeftRtgsAccount({ loading: false }));
      });
  };

  return (
    <Modal
      header="NEFT and RTGS Account Details"
      headerClass="flex items-center justify-between w-full text-[22px] font-semibold"
      modalClass="bg-gray-200"
      visible={visible}
      maskClosable={false}
      closeHandler={() => {
        dispatch(remittanceActions.setModalType(""));
      }}
      closable={true}
    >
      {/* BODY */}
      <div className="flex flex-col items-center space-y-6 mt-10">
        {/* Account Details */}
        <div className="w-full bg-gray-50 border rounded-lg p-5 space-y-3">
          <DetailRow
            label="Account type: "
            value={payment?.neftRtgsBankDetails?.data?.accountType ?? "Current Account"}
          />
          <DetailRow
            label="Account Holder Name:"
            value={payment?.neftRtgsBankDetails?.data?.accountHolderName ?? ""}
          />
          <DetailRow
            label="Bank Name:"
            value={payment?.neftRtgsBankDetails?.data?.bankName ?? ""}
          />
          <DetailRow
            label="Account Number:"
            value={payment?.neftRtgsBankDetails?.data?.accountNumber ?? ""}
          />
          <DetailRow
            label="IFSC Code:"
            value={payment?.neftRtgsBankDetails?.data?.ifscCode ?? ""}
          />
        </div>

        {/* Share Button */}
        <Button
          className="border font-semibold border-blue-500 text-blue-600 w-[230px] h-[54px] rounded"
          bgColor="white"
          onClickHandler={onClickShareAccDetails}
          isLoading={payment?.shareNeftRtgsAccount.loading}
        >
          Share A/C Details
        </Button>

        {/* Notes */}
        <div className="w-full bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-2">
          <p className="text-sm text-blue-700 font-semibold">Note:</p>
          <p className="text-sm text-blue-700">
            • The Payment should be made in the next 30 working hours.
          </p>
          <p className="text-sm text-blue-700">
            • Please make sure that the payment is being made from the remitter’s account only
            otherwise the transation might be rejected.
          </p>

          {transactionDetail?.data?.purposeCode !== "S0305" ? (
            <>
              <p className="text-sm text-blue-700">
                • Your payment status will get updated during banking hours, For any queries, do
                reach us at hello@moneyhop.co
              </p>
            </>
          ) : (
            <>
              <p className="text-sm text-blue-700">
                • After making the bank transfer,it may take up to 1 hour to get the payment status
                updated.
              </p>
            </>
          )}

          <p className="text-sm text-blue-700">
            • Optional- You can upload the payment proof after the fund transfer in the History tab.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col items-center space-y-4 mt-4">
          <Button
            onClickHandler={() => {
              navigate("/send/confirmation");
            }}
            className="font-semibold text-white w-[230px] h-[54px] rounded"
            bgColor="bg-primary-1050"
          >
            Confirm
          </Button>

          <Button
            onClickHandler={() => {
              navigate("/home");
              dispatch(remittanceActions.resetRemittanceState());
            }}
            className="font-semibold text-primary-1050 w-[230px] h-[54px]"
            bgColor="white"
          >
            Go Home
          </Button>
        </div>
      </div>
    </Modal>
  );
};
